import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './show_more_btn.module.css';

const ShowMoreBtn = ({ title, url, isClear }) => {
  const navigate = useNavigate();

  const goToPage = (e) => {
    e.preventDefault();
    navigate(url /* { state: { from: pathname } } */);
  };

  return (
    <>
      <span className={styles.button} onClick={goToPage}>
        {isClear ? `${title} >` : `${title}에서 더보기 >`}
      </span>
    </>
  );
};

export default ShowMoreBtn;
